import Attendance from "screens/private/attendance";
export default Attendance;
